export default {"src":"https://images-cdn.curipod.com/d-3fd83b4e/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};